// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 493) return "static/chunks/bf5f3635.730038c2b861858f.js";
	if (chunkId === 950) return "static/chunks/950.a0cf6b352c0afc47.js";
	if (chunkId === 289) return "static/chunks/289.d875bffe3f2d3fa0.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 501 ? "144d3bae" : chunkId) + "-" + {"74":"6d624c970ebeb023","336":"73dc9dfd61804681","466":"a2b740fbfe17cf50","501":"60a95f4f26178ad3"}[chunkId] + ".js";
};